import React, {Component} from 'react';
import $ from 'jquery'
import * as Common from '../CommonControlls/CommonJs';
import MainLayout from '../CommonControlls/MainLayout';
import Topmenu from '../CommonControlls/Topmenubar';
import {connect} from 'react-redux'
import {Link} from 'react-router-dom';
import {SelectCompleteDistrictsList, SelectAllProvince, SelectTehsil} from '../OfflineDb/IndexDbTranscSP'
import AlertModal from '../CommonControlls/AlertModal';
import {SyncConfig} from '../OfflineDb/ConfigDataSync'
import DropDown from '../CommonControlls/DropdownRendrer'


const mapStateToProps = (store) => {
    return store
}

const mapDispatchToProps = (dispatch) => {
    return {
        ShowAlert: (Settings) => {
            dispatch({type: "UpdateAlert", payload: Settings})
        },
        ShowLoader: (Isloading) => {
            dispatch({type: "UpdateLoader", payload: Isloading})
        },
    }
}

class Tehsil_Add extends Component {

    constructor(props) {
        super(props);
        this.state = {
            Id: 0,

            alertModalData: {
                title: "",
                message: "",
                First_Callback: () => {
                },
                Second_Callback: () => {
                },
                type: 1,
            },

            ProvinceLoader: false,
            Provincelist: [],
            ProvinceId: 0,

            DistrictLoader: false,
            Districtlist: [],
            FilteredDistrictlist: [],
            DistrictId: 0,

        };
    }

    HandleAutoSuggestValChange = (fieldId, value) => {
        this.setState({[fieldId]: value}, () => {
            if (fieldId == "ProvinceId") {
                var TempArr = this.state.Districtlist
                var filteredArr = TempArr.filter(function (obj) {
                    return obj.provinceId == value;
                });
                this.setState({
                    FilteredDistrictlist: filteredArr,
                })
            }
        })
    }

    render() {

        return (

            <div>
                <AlertModal  {...this.state.alertModalData} />
                <MainLayout/>
                <div id="right-panel" class="right-panel">
                    <Topmenu PageTitle={this.state.Id == 0 ? "Add Tehsil" : "Edit Tehsil"} isShowAddBtn={false}/>
                    <div class="content">

                        {/* <div class="PageHeader_Container">
                <h2>{this.state.Id==0?"Add Tehsil":"Edit Tehsil"}</h2>
            </div> */}

                        <div class="card col-lg-5 col-md-5 col-sm-12 col-xs-12">
                            <div class="card-body row">
                                <form onSubmit={this.SubmitForm} novalidate>

                                    <div class="row">
                                        <div class="formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                            <label for=""><span style={{color: "red"}}>* </span>Province</label>
                                            <DropDown
                                                multi={false}
                                                dropdownRenderer={false}
                                                create={false}
                                                onChange={this.HandleAutoSuggestValChange}
                                                Type="ProvinceId"
                                                options={this.state.Provincelist}
                                                val={this.state.ProvinceId}
                                                addPlaceholder=""
                                                disabled={false}
                                                loading={this.state.ProvinceLoader}
                                                searchBy="name"
                                                labelField="name"
                                                valueField="id"
                                                contentRenderer={false}
                                                placeholder="Select"
                                            />
                                        </div>

                                        <div class="formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                            <label for=""><span style={{color: "red"}}>* </span>District</label>
                                            <DropDown
                                                multi={false}
                                                dropdownRenderer={false}
                                                create={false}
                                                onChange={this.HandleAutoSuggestValChange}
                                                Type="DistrictId"
                                                options={this.state.FilteredDistrictlist}
                                                val={this.state.DistrictId}
                                                addPlaceholder=""
                                                disabled={false}
                                                loading={this.state.DistrictLoader}
                                                searchBy="name"
                                                labelField="name"
                                                valueField="id"
                                                contentRenderer={false}
                                                placeholder="Select"
                                            />
                                        </div>

                                        <div class="formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                            <label for=""><span style={{color: "red"}}>* </span>Tehsil Name</label>
                                            <input autocomplete="off" type="text" class="form-control" id="TehsilName"
                                                   placeholder="Enter Tehsil name" required/>
                                        </div>

                                        <div
                                            class="form_footer formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                            <button type="submit" id="Form_SaveBtn" class="btn btn_style1">Save</button>
                                            <button type="button" id="Form_DeleteBtn" onClick={this.onDelete}
                                                    hidden={this.state.Id == 0 ? true : false}
                                                    class="btn btn_style2">Delete
                                            </button>
                                            <Link to="/Tehsil">
                                                <button type="button" id="Form_CancelBtn"
                                                        class="btn btn_style3">Cancel
                                                </button>
                                            </Link>

                                            {/* Hide button for reset */}
                                            <Link style={{display: "none"}} to="/Tehsil_Add">
                                                <button id="Form_ResetBtn" type="button"
                                                        class="btn initial-btn Cancel-Form-btn Form_Btn">Reset
                                                </button>
                                            </Link>

                                        </div>

                                    </div>


                                </form>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

        )
    }

    componentWillMount() {
        if (this.props.UserAuthentication.AuthToken === "") {
            this.props.history.push("/Login")
        }
    }

    componentDidMount() {
        Common.AddClassToMenueLink("MenuLink_Tehsil", true, "MenuParentLink_Geography")
        // Common.AddClassToMenueLink("MenuLink_Districts")
        this.GetPageConfigData(() => {
            var Id = Common.GetId()
            if (Id !== 0) {
                this.selectTehsilDetails(Id)
            }
        })
    }

    GetPageConfigData = (CallBack) => {
        this.props.ShowLoader({Isloading: true})
        var d1 = $.Deferred();
        var d2 = $.Deferred();
        this.SelectProvinces(() => {
            d1.resolve()
        })
        this.SelectDistricts(() => {
            d2.resolve()
        })
        $.when(d1, d2).done(() => {
            this.props.ShowLoader({Isloading: false})
            CallBack()
        });
    }
    SelectProvinces = (Callback) => {
        this.setState({ProvinceLoader: true})
        Common.Ajax(this.props.UserAuthentication.AuthToken, 'GET', false, Common.APILinks.SelectAll_Province, {}, (data) => {
            this.setState({
                ProvinceLoader: false,
                Provincelist: data.data
            })
            Callback()
        }, (error) => {
            this.setState({ProvinceLoader: false})
            this.props.ShowAlert({Type: 0, Msg: error})
            setTimeout(function () {
                $("#Alertmsgbtn").click()
            }, 50);
            Callback()
        })
    }
    SelectDistricts = (Callback) => {
        this.setState({DistrictLoader: true})
        Common.Ajax(this.props.UserAuthentication.AuthToken, 'GET', false, Common.APILinks.SelectAll_District, {}, (data) => {
            this.setState({
                DistrictLoader: false,
                Districtlist: data.data
            })
            Callback()
        }, (error) => {
            this.setState({DistrictLoader: false})
            this.props.ShowAlert({Type: 0, Msg: error})
            setTimeout(function () {
                $("#Alertmsgbtn").click()
            }, 50);
            Callback()
        })
    }
    selectTehsilDetails = (Id) => {
        this.props.ShowLoader({Isloading: true})
        Common.Ajax(this.props.UserAuthentication.AuthToken, 'GET', false, Common.APILinks.SelectAll_Tehsil,  {}, (resp) => {
            this.props.ShowLoader({Isloading: false})
            if (resp.status) {
                const selected = resp.data.find(item => item.id === Id)
                this.LoadDataInEditMode(selected)
            }

        }, (error) => {
            this.props.ShowLoader({Isloading: false})
            this.props.ShowAlert({Type: 0, Msg: error})
            setTimeout(function () {
                $("#Alertmsgbtn").click()
            }, 50);
        })
    }
    LoadDataInEditMode = (data) => {
        this.setState({
            Id: data.id,
            ProvinceId: data.provinceId,
            DistrictId: data.districtId,
        })
        $("#TehsilName").val(data.name)
    }
    ResetForm = () => {
        this.setState({
            Id: 0,
            ProvinceId: 0,
            DistrictId: 0,
        })
        $("#TehsilName").val("")
    }
    SubmitForm = (e) => {
        e.preventDefault()
        this.props.ShowLoader({Isloading: true})
        var Parameters = {
            id: this.state.Id,
            name: $("#TehsilName").val(),
            provinceId: this.state.ProvinceId,
            districtId: this.state.DistrictId,
        }
        Common.Ajax(this.props.UserAuthentication.AuthToken, "Post", false,
            this.state.Id == 0 ? Common.APILinks.Save_Tehsil : Common.APILinks.Update_Tehsil, JSON.stringify(Parameters), (resp) => {
                if (resp.status == true) {
                    SyncConfig(() => {
                            if (this.state.Id != 0)
                                $("#Form_ResetBtn").click()
                            this.ResetForm()
                            this.props.ShowLoader({Isloading: false})
                            this.props.ShowAlert({Type: 1, Msg: "Saved successfully"})
                            setTimeout(() => {
                                $("#Alertmsgbtn").click()
                            }, 50);
                        },
                        () => {
                            if (this.state.Id != 0)
                                $("#Form_ResetBtn").click()
                            this.ResetForm()
                            this.props.ShowLoader({Isloading: false})
                            this.props.ShowAlert({Type: 0, Msg: "Error in sync, please reload the page"})
                            setTimeout(function () {
                                $("#Alertmsgbtn").click()
                            }, 50);
                        })
                } else {
                    this.props.ShowLoader({Isloading: false})
                    this.props.ShowAlert({Type: 0, Msg: resp.message})
                    setTimeout(() => {
                        $("#Alertmsgbtn").click()
                    }, 50);
                }
            },
            (error) => {
                this.props.ShowLoader({Isloading: false})
                this.props.ShowAlert({Type: 0, Msg: "Something went wronge, please try again."})
                setTimeout(() => {
                    $("#Alertmsgbtn").click()
                }, 50);
            })

    }
    onDelete = () => {
        this.setState({
            alertModalData: {
                title: "Delete Tehsil",
                message: "Are you sure you want to delete this record.",
                First_Callback: () => {
                    $("#Generic-modal-CloseBtn").click();
                    this.DeleteRecord()
                },
                Second_Callback: () => {
                    $("#Generic-modal-CloseBtn").click()
                },
                type: 1,
            }
        }, () => {
            $("#Show_ArletModal").click()
        })
    }
    DeleteRecord = () => {
        this.props.ShowLoader({Isloading: true})
        Common.Ajax(this.props.UserAuthentication.AuthToken, "Get", false, Common.APILinks.Delete_Tehsil, {Id: this.state.Id},
            (Result) => {
                if (Result.status == true) {
                    SyncConfig(() => {
                        $("#Form_CancelBtn").click()
                        this.props.ShowLoader({Isloading: false})
                        this.props.ShowAlert({Type: 1, Msg: "Deleted Successfully."})
                        setTimeout(function () {
                            $("#Alertmsgbtn").click()
                        }, 50);
                    }, () => {
                        this.props.ShowLoader({Isloading: false})
                        this.props.ShowAlert({Type: 0, Msg: "Error in sync, please reload the page"})
                        setTimeout(function () {
                            $("#Alertmsgbtn").click()
                        }, 50);
                    })
                } else {
                    this.props.ShowLoader({Isloading: false})
                    this.props.ShowAlert({Type: 0, Msg: Result.message})
                    setTimeout(function () {
                        $("#Alertmsgbtn").click()
                    }, 50);
                }
            },
            (error) => {
                this.props.ShowLoader({Isloading: false})
                this.props.ShowAlert({Type: 0, Msg: "Something went wronge, please try again."})
                setTimeout(function () {
                    $("#Alertmsgbtn").click()
                }, 50);
            })
    }

}

export default connect(mapStateToProps, mapDispatchToProps)(Tehsil_Add);
